import React from 'react'
import TopHeader from '../home/TopHeader'
import Breadcrumbs from '../common/Breadcrumbs'
import Footer from '../home/Footer'

export default function RefundPolicy() {
  return (
    <div>
      <TopHeader />
      <Breadcrumbs main={"Refund Policy"} parent={"Refund Policy"} />
      <div className='container'>
        <h4>Refund Policy</h4>
        <p>
          At H N Store, customer satisfaction is our top priority. This Refund Policy
          explains the conditions under which refunds may be issued, the process for requesting
          a refund, and the timelines involved. By making a purchase on our website, you agree to
          the terms outlined below.
        </p>

        <h4>Eligibility for Refunds</h4>
        <ul>
          <li>
            <strong>Damaged or Defective Products:</strong> If you receive a product that is damaged,
            defective, or not as described, you may be eligible for a full refund.
          </li>
          <li>
            <strong>Order Cancellations:</strong> Orders can be canceled within <strong>24 hours</strong> of purchase
            if the product has not yet been shipped. In such cases, a full refund will be issued.
          </li>
          <li>
            <strong>Non-Delivery:</strong> If your order does not arrive within the promised delivery timeframe,
            you may request a refund.
          </li>
          <li>
            <strong>Change of Mind:</strong> Refunds for change of mind are not guaranteed. However,
            requests will be considered on a case-by-case basis.
          </li>
        </ul>

        <h4>Refund Process</h4>
        <ol>
          <li>
            <strong>Request:</strong> To initiate a refund, please email our support team at{" "}
            <a href="mailto:hnstoreuser@gmail.com">hnstoreuser@gmail.com</a> within
            <strong> 7 days</strong> of receiving your order. Include your order number, issue details,
            and supporting evidence (such as photos).
          </li>
          <li>
            <strong>Review:</strong> Our team will review your request and respond within{" "}
            <strong>3 business days</strong>.
          </li>
          <li>
            <strong>Return (if applicable):</strong> If a product return is required, you will be
            informed of the process. Customers are responsible for return shipping costs unless
            the product was damaged, defective, or incorrect.
          </li>
          <li>
            <strong>Refund Issuance:</strong> Approved refunds will be processed within{" "}
            <strong>5–7 business days</strong> and credited to the original payment method used during checkout.
          </li>
        </ol>

        <h4>Non-Refundable Items</h4>
        <ul>
          <li>Products returned after the 7-day window</li>
          <li>Products used, damaged, or not in original condition</li>
          <li>Customized or special-order products</li>
        </ul>

        <h4>Payment Gateway Charges</h4>
        <p>
          In some cases, transaction fees charged by the payment gateway may be non-refundable.
          These will be communicated clearly during the refund process.
        </p>

        <h4>Contact Us</h4>
        <p>
          For refund-related queries, please contact our support team: <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:hnstoreuser@gmail.com">hnstoreuser@gmail.com</a> <br />
        </p>
      </div>
      <Footer />
    </div>
  )
}
